import { Flex, Heading, useMediaQuery } from '@chakra-ui/react'
import {
  ConnectedFormGroup,
  ConnectedImageUploader,
  ConnectedTextArea
} from 'components/FormElements'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { VscMail } from 'react-icons/vsc'

const AgencyInfo: React.FC = () => {
  const { t } = useTranslation()
  const [isTabletOrMobile] = useMediaQuery('(max-width: 40em)')
  return (
    <>
      <Heading my={2} size="lg" textAlign="left">
        {t('signup.agency.agency_info')}
      </Heading>
      <Flex direction={isTabletOrMobile ? 'column' : 'row'}>
        <ConnectedFormGroup
          mr={isTabletOrMobile ? 0 : 2}
          flex={1}
          name="agencyName"
          label={t('signup.agency.name_label')}
          placeholder="Agency Name"
        />
        <ConnectedFormGroup
          name="agencyWebsite"
          flex={1}
          label={t('signup.agency.website')}
          placeholder="e.g: www.nsoko.io"
        />
      </Flex>
      <Flex direction={isTabletOrMobile ? 'column' : 'row'}>
        <ConnectedFormGroup
          name="agencyEmail"
          mr={isTabletOrMobile ? 0 : 2}
          flex={1}
          leftIcon={VscMail}
          label={t('signup.agency.email')}
          placeholder="e.g: support@nsoko.io"
        />
        <ConnectedFormGroup
          name="agencyPhone"
          label={t('signup.agency.phone_number')}
          flex={1}
          placeholder="e.g: 08198765432"
        />
      </Flex>
      <ConnectedFormGroup
        name="agencyAddress"
        label={t('signup.agency.address')}
        placeholder="e.g: 4 Nsoko street, Cape Town, South Africa"
      />
      <ConnectedTextArea
        name="agencyDescription"
        label={t('signup.agency.description')}
        placeholder="Agency Description"
      />
      <ConnectedImageUploader label="Agency Logo" name="agencyLogo" />
    </>
  )
}

export default AgencyInfo
